export default "__VITE_ASSET__BHLs11po__"